export default __webpack_public_path__ + "static/media/IconWarning.67e746a2.svg";